import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_COURSE = requestConstantsMaker('GET_ALL_COURSE');
export const GET_COURSE = requestConstantsMaker('GET_COURSE');
export const CREATE_COURSE = requestConstantsMaker('CREATE_COURSE');
export const UPDATE_COURSE = requestConstantsMaker('UPDATE_COURSE');
export const GET_COURSES_FOR_SELECTION = requestConstantsMaker('GET_COURSES_FOR_SELECTION');
export const GET_SUMMER_COURSES_FOR_SCHEDULE = requestConstantsMaker('GET_SUMMER_COURSES_FOR_SCHEDULE');
/**** 20200217 ****/